import { render, staticRenderFns } from "./brandItem.vue?vue&type=template&id=3cad99cc&scoped=true"
import script from "./brandItem.vue?vue&type=script&lang=js"
export * from "./brandItem.vue?vue&type=script&lang=js"
import style0 from "./brandItem.vue?vue&type=style&index=0&id=3cad99cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cad99cc",
  null
  
)

export default component.exports